import { useDispatch } from 'react-redux'
import { configureStore } from "@reduxjs/toolkit";
import authSlice from './auth/slice'
import currentUserSlice from './current-user/slice'
import notificationSlice from './notifications/slice'
import homeGraphSlice from './home/slice'
import bookingSlice from './bookings/slice'
import bookingDetailSlice from './booking-detail/slice'
import scheduleListSlice from "./schedule/summary/slice";
import scheduleSlice from "./schedule/detail/slice";
import couponSlice from './coupon/slice';
import calendarSlice from './calendar/slice';
import calendarWeeklySlice from './calendar-weekly/slice';
import venueDetailSlice from './venue-detail/slice'
import venueSummarySlice from './venue-summary/slice'
import venueSummaryTempSlice from './venue-summary-temp/slice'
import programSummary from './program-summary/slice'
import programDetail from './program-detail/slice'
import HolidaySlice from './holiday/slice'
import NewsSlice from './news/slice'
import CustomerSlice from './customer/slice'
import UserSlice from './user/slice'
import RoleSlice from './role/slice'
import InvoiceSlice from './invoice/slice'
import UserInfoSlice from './user-info/slice'
import MenuListSlice from './menu-list/slice'
import SubscriptionSlice from './subscription/slice'
import SubscriptionDetailSlice from './subscription-detail/slice'
import IncomeStatement from './income-statement/slice'
import BookingInsight from './booking-insight/slice'
import FileSlice from './file/slice'
import RefundSummarySlice from './refund-summary/slice'
import RefundDetailSlice from './refund-detail/slice'
import RefundFormDetailSlice from './refund-form/slice'
import VideoSlice from './video/slice'
import PhotoSlice from './photo/slice'
import ClubSlice from './clubs/slice'

const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    currentUser: currentUserSlice.reducer,
    notification: notificationSlice.reducer,
    homeGraph: homeGraphSlice.reducer,
    booking: bookingSlice.reducer,
    bookingDetail: bookingDetailSlice.reducer,
    scheduleList: scheduleListSlice.reducer,
    schedule: scheduleSlice.reducer,
    coupon: couponSlice.reducer,
    calendar: calendarSlice.reducer,
    calendarWeekly: calendarWeeklySlice.reducer,
    venueDetail: venueDetailSlice.reducer,
    venueSummary: venueSummarySlice.reducer,
    venueSummaryTemp: venueSummaryTempSlice.reducer,
    programSummary: programSummary.reducer,
    programDetail: programDetail.reducer,
    holiday: HolidaySlice.reducer,
    customer: CustomerSlice.reducer,
    user: UserSlice.reducer,
    roles: RoleSlice.reducer,
    invoice: InvoiceSlice.reducer,
    userInfo: UserInfoSlice.reducer,
    menuList: MenuListSlice.reducer,
    subscription: SubscriptionSlice.reducer,
    subscriptionDetail: SubscriptionDetailSlice.reducer,
    incomeStatement: IncomeStatement.reducer,
    bookingInsight: BookingInsight.reducer,
    file: FileSlice.reducer,
    news: NewsSlice.reducer,
    refundSummary: RefundSummarySlice.reducer,
    refundDetail: RefundDetailSlice.reducer,
    refundForm: RefundFormDetailSlice.reducer,
    video: VideoSlice.reducer,
    photo: PhotoSlice.reducer,
    club: ClubSlice.reducer
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch
export default store
